import React, { useEffect, useState } from 'react';
import { surveillerVersion } from '../services/version';

/**
 * « Une nouvelle version est disponible. »
 *
 * Posé en bas de l'écran, au-dessus de tout, et jamais bloquant : le
 * technicien peut l'ignorer et finir son compte rendu. Recharger au mauvais
 * moment lui coûterait ses photos — c'est donc lui qui choisit l'instant.
 *
 * Le bouton vide d'abord le cache du service worker : sans cela, un
 * rechargement peut resservir exactement le même paquet.
 */
export default function BandeauVersion() {
  const [dispo, setDispo] = useState(false);

  useEffect(() => surveillerVersion(() => setDispo(true)), []);

  if (!dispo) return null;

  const recharger = async () => {
    try {
      if (window.caches) {
        const cles = await caches.keys();
        await Promise.all(cles.map(c => caches.delete(c)));
      }
      if (navigator.serviceWorker) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.update()));
      }
    } catch { /* on recharge quand meme */ }
    window.location.reload();
  };

  return (
    <div style={{
      position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 9999,
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      padding: '12px 14px', borderRadius: 10,
      background: 'var(--fond-carte, #1f2937)', color: 'var(--texte, #fff)',
      border: '1px solid var(--bordure, rgba(255,255,255,0.15))',
      boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
    }}>
      <div style={{ flex: 1, minWidth: 180, fontSize: 13, lineHeight: 1.35 }}>
        <strong>Nouvelle version disponible.</strong><br />
        <span style={{ opacity: 0.75 }}>
          Terminez votre compte rendu, puis rechargez.
        </span>
      </div>
      <button onClick={() => setDispo(false)} style={{
        padding: '8px 12px', fontSize: 13, cursor: 'pointer', borderRadius: 8,
        border: '1px solid rgba(255,255,255,0.25)', background: 'transparent',
        color: 'inherit',
      }}>plus tard</button>
      <button onClick={recharger} style={{
        padding: '8px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
        borderRadius: 8, border: 0, background: 'var(--accent, #2563eb)', color: '#fff',
      }}>recharger</button>
    </div>
  );
}
